import { useEffect } from "react";
import { documentService } from "../../services";
import { IFolder } from "../../customTypings/document/Folder";

interface PathFolder {
  text: string;
  absolutePath: string;
}

export const useDocumentPath = (
  taskId: string | undefined,
  currentPath: string,
  defaultFolder: string,
  setPathFolders: (folders: PathFolder[]) => void,
  setCurrentFolder: (folder: IFolder) => void,
  setAlertMessage: (message: string) => void
) => {
  useEffect(() => {
    setAlertMessage("");

    const baseFolder = {
      text: "Root" + defaultFolder,
      absolutePath: defaultFolder,
    } as PathFolder;

    const remainingPath = currentPath.substring(defaultFolder.length);
    const pathComponents =
      remainingPath === "/" ? [""] : remainingPath.split("/");
    let acc = defaultFolder;
    let pathFolders = [] as PathFolder[];
    pathFolders.push(baseFolder);

    const remainingFolders = pathComponents
      .filter((p) => p.length > 0)
      .map((p) => {
        acc += (acc.endsWith("/") ? "" : "/") + p;
        if (p.length === 0) p = "Root";
        return { text: p, absolutePath: acc } as PathFolder;
      });

    pathFolders = pathFolders.concat(remainingFolders);
    setPathFolders(pathFolders);

    documentService
      .getFolderByPath(taskId, currentPath)
      .then((response: IFolder) => {
        setCurrentFolder(response);
      })
      .catch((rejected) => {
        setAlertMessage("Could not retrieve folder: " + rejected);
      });
  }, [currentPath, defaultFolder, taskId, setPathFolders, setCurrentFolder, setAlertMessage]);

  const handleSelectFolder = (folder: IFolder, currentPath: string, setCurrentPath: (path: string) => void) => {
    if (currentPath.endsWith("/")) setCurrentPath(currentPath + folder.name);
    else setCurrentPath(currentPath + "/" + folder.name);
  };

  const onUpFolder = (currentPath: string, setCurrentPath: (path: string) => void) => {
    if (currentPath !== "/" && currentPath.length !== 0) {
      let newPath = currentPath.substring(0, currentPath.lastIndexOf("/"));
      if (!newPath.startsWith("/")) newPath = "/" + newPath;
      setCurrentPath(newPath);
    }
  };

  return {
    handleSelectFolder,
    onUpFolder,
  };
};
